module.exports = {
          srcSet: __webpack_public_path__ + "images/2010-e1a2e04d0a3e8ff0bfd4e0c088c898b7-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2010-84d3de0e0ec6d2a6368c28e7f529e325-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2010-e1a2e04d0a3e8ff0bfd4e0c088c898b7-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2010-84d3de0e0ec6d2a6368c28e7f529e325-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2010-e1a2e04d0a3e8ff0bfd4e0c088c898b7-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2010-e1a2e04d0a3e8ff0bfd4e0c088c898b7-320.jpg"},
          
          width: 320,
          height: 251
        }